import { DBDef_Resource } from '@app/hcs-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_Resource, ModuleFE_Tag, ModuleFE_Variable } from '../../_entity.js';
import { Manager_Resource } from '../../ui/_managers/Manager_Resource/Manager_Resource.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_Resource,
    dbDef: DBDef_Resource,
    tag: ['Rs', 'Resource'],
    modulesToAwait: [ModuleFE_Resource, ModuleFE_Tag, ModuleFE_Variable],
    ManagerComponent: Manager_Resource,
    resultSubtitle: (resource) => resource?.type,
});
export const WorkHubItem_Resource = WorkHubItem;
export const UtilObject_Resource = UtilObject;
export const SearchItem_Resource = SearchItem;
//# sourceMappingURL=resource.js.map